/* eslint-disable no-nested-ternary */
import React, { Component } from "react";
import PropTypes from "prop-types";
import matchSorter from "match-sorter";
import ReactTable from "react-table";
import { connect } from "react-redux";

import TableActions from "../common/TableActions";
import ResponsiveDataComponent from "../common/ResponsiveDataComponent";

import { formatDate } from "../../helpers/date";

import { getCanEdit } from "./ExpenseEditPage";

class ExpenseList extends Component {
  render() {
    let {
      onClickView,
      onClickDelete,
      isMobile,
      search,
      expenses,
      minimal,
      defaultPageSize,
      onPageSizeChange,
      pages
    } = this.props;

    const columns = !isMobile
      ? [
          {
            Header: "Date",
            accessor: "date",
            Cell: (row) => formatDate(row.value, "MM/dd/yy")
          },
          { Header: "Customer", accessor: "customer.name" },
          { Header: "Category", accessor: "category.label" },
          {
            Header: "Total",
            accessor: "total",
            Cell: (row) =>
              `$ ${row.value.toLocaleString(undefined, {
                maximumFractionDigits: 2
              })}`
          },
          { Header: "Status", accessor: "status.label" },
          {
            id: "bill",
            Header: "Bill Customer",
            accessor: (expense) => {
              if (expense.bill_to_customer) {
                if (expense.to_customer_complete) {
                  return "Complete";
                }
                return "Pending";
              }
              return "-";
            },
            Cell: (row) => row.value
          },
          {
            id: "reimburse",
            Header: "Reimburse",
            accessor: (expense) => {
              if (expense.reimburse_to_employee) {
                if (expense.to_employee_complete) {
                  return "Complete";
                }
                return "Pending";
              }
              return "-";
            },
            Cell: (row) => row.value
          },
          {
            id: "annual",
            Header: "Annual",
            accessor: (expense) => {
              if (expense.occurs_annually) {
                return "Yes";
              }
              return "-";
            },
            Cell: (row) => row.value
          }
        ]
      : [
          {
            Header: "Date",
            accessor: "date",
            Cell: (row) => formatDate(row.value, "MM/dd/yy")
          },
          { Header: "Status", accessor: "status.label" }
        ];

    columns.push({
      accessor: "_id",
      maxWidth: 80,
      sortable: false,
      Cell: (row) =>
        getCanEdit(row.original, this.props.codes) ? (
          <TableActions
            onClickView={() => onClickView(row.value)}
            onClickDelete={() => onClickDelete(row.value)}
          />
        ) : (
          <TableActions onClickView={() => onClickView(row.value)} />
        )
    });

    const props = {
      getTdProps: (state, rowInfo, column) => {
        if (!column.expander && rowInfo?.original?._id) {
          return {
            onClick: () =>
              column.id !== "_id" && onClickView(rowInfo.original._id)
          };
        }
        return {};
      }
    };

    if (search) {
      expenses = matchSorter(expenses, search, {
        keys: [
          "date",
          "customer.name",
          "category.label",
          "total",
          "status.label"
        ]
      });
    }

    return (
      <ReactTable
        {...props}
        className="-highlight"
        pages={pages}
        data={expenses}
        columns={columns}
        defaultSorted={[
          {
            id: "date",
            desc: true
          }
        ]}
        showPageSizeOptions={!isMobile}
        defaultPageSize={
          minimal && expenses.length < 5 ? expenses.length + 1 : defaultPageSize
        }
        {...(minimal && {
          pageSize:
            minimal && expenses.length < 5
              ? expenses.length + 1
              : defaultPageSize
        })}
        showPagination={expenses.length > 5}
        // LoadingComponent={() => <Loading active={loading} />}
        onPageSizeChange={onPageSizeChange}
        SubComponent={
          isMobile
            ? ({ original }) => (
                <ResponsiveDataComponent
                  data={[
                    {
                      key: "Employee",
                      label: original.employee.full_name || "--"
                    },
                    {
                      key: "Customer",
                      label: original.customer.name || "--"
                    },
                    {
                      key: "Category",
                      label: original.category.label || "--"
                    },
                    {
                      key: "Total",
                      label:
                        `$ ${original.total.toLocaleString(undefined, {
                          maximumFractionDigits: 2
                        })}` || "--"
                    },
                    {
                      key: "Bill Customer",
                      label: original.bill_to_customer
                        ? original.to_customer_complete
                          ? "Completed"
                          : "Pending"
                        : "-"
                    },
                    {
                      key: "Reimburse",
                      label: original.reimburse_to_employee
                        ? original.to_employee_complete
                          ? "Completed"
                          : "Pending"
                        : "-"
                    }
                  ]}
                />
              )
            : false
        }
      />
    );
  }
}

ExpenseList.propTypes = {
  onClickView: PropTypes.func.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  isMobile: PropTypes.bool,
  search: PropTypes.string,
  expenses: PropTypes.array,
  codes: PropTypes.array,
  minimal: PropTypes.bool,
  defaultPageSize: PropTypes.number,
  onPageSizeChange: PropTypes.func,
  pages: PropTypes.number
};

const mapStatesToProps = (state) => ({
  state: state.reducers,
  codes: state.reducers.codes
});

export default connect(mapStatesToProps)(ExpenseList);
